"use client"

import React, { useEffect, useState } from "react";
import { useAppContext } from "../../../contexts/AppProvider";
import { useNavigate } from "react-router-dom";

interface formData{
    name?: string,
    email: string,
    password: string,
    password_confirmation?: string
}

const Troypus: React.FC = () => {

    const [isLogin, setislogin] = useState<boolean>(true)
    const [formData, setFormData] = useState<formData>({
        name: "",
        email: "",
        password: "",
        password_confirmation: ""
    })

    const { login, register, authToken, isLoading } = useAppContext()
    const navigate = useNavigate();

    useEffect( ()=> {
        if(authToken){
            navigate("/dashboard");
            return
        }
    }, [authToken, isLoading])

    const handleOnChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        })
    };

    const handleOnSubmit = async(event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if(isLogin){
            try {
                await login(formData.email, formData.password)
            } catch (error) {
                console.log(`Login Error ${error}`)
            }
        } else {
            try {
                await register(formData.name!, formData.email, formData.password, formData.password_confirmation!)
            } catch (error) {
                console.log(`Register Error ${error}`)
            }
        }
    };

    return (
        <div className="flex justify-center items-center min-h-[calc(100vh-4rem)]">
            <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
                <h3 className="text-2xl font-bold text-center text-gray-800 mb-6">
                    {isLogin ? "Login" : "Register"}
                </h3>
                <form onSubmit={handleOnSubmit} className="space-y-4">
                    {!isLogin && (
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                            <input
                                type="text"
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleOnChangeInput}
                                required
                            />
                        </div>
                    )}
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                        <input
                            type="email"
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleOnChangeInput}
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                        <input
                            type="password"
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleOnChangeInput}
                            required
                        />
                    </div>
                    {!isLogin && (
                        <div>
                            <label htmlFor="password_confirmation" className="block text-sm font-medium text-gray-700">
                                Confirm Password
                            </label>
                            <input
                                type="password"
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                                id="password_confirmation"
                                name="password_confirmation"
                                value={formData.password_confirmation}
                                onChange={handleOnChangeInput}
                                required
                            />
                        </div>
                    )}
                    <button
                        type="submit"
                        className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                        disabled={isLoading}
                    >
                        {isLoading ? "Loading..." : (isLogin ? "Login" : "Register")}
                    </button>
                </form>
                <div className="text-center mt-4">
                    <button
                        className="text-sm text-blue-600 hover:text-blue-500"
                        onClick={() => setislogin(!isLogin)}
                        disabled={isLoading}
                    >
                        {isLogin ? "Don't have an account? Register" : "Already have an account? Login"}
                    </button>
                </div>
            </div>
        </div>
    );
    };

export default Troypus;